export const paychexPerksWorkerTypes = {
  EMPLOYEE: "EMPLOYEE",
  INDEPENDENT_CONTRACTOR: "INDEPENDENT_CONTRACTOR",
} as const;

export type PaychexPerksWorkerType =
  (typeof paychexPerksWorkerTypes)[keyof typeof paychexPerksWorkerTypes];

export const paychexWorkerStatuses = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;
